var generic = window.generic || {};
var randomPrize = window.randomPrize || {};

(function ($) {
  var $document = $(document);
  var COOKIE_DELIMITER = '|';

  Drupal.behaviors.spinGameV1 = {
    attach: function (context) {
      // Properties
      var isSpinningActive = false;
      var spinsLeft = 3;
      var totalTries = randomPrize.settings.numberOfTries || spinsLeft;
      var currentTry = 0;
      var gameTransitionDelay = 1000;
      var slotHeight;
      var scrollTopDuration = 500;
      var zeroVal = 0;
      var oneVal = 1;
      var currentlyShowing = [];
      var $formatter = $('.js-random-gift-picker-formatter-v1');
      var $applyOfferBtn = $('.js-apply-offer', $formatter);
      var $slotsGameContainer = $('.js-game-container', context);
      var $playNowBtn = $('.js-game-play-now', $slotsGameContainer);
      var $slotContainer = $('.js-game-slot-container', $slotsGameContainer);
      var $slotImageContainer = $('.js-game-slot-image', $slotsGameContainer);
      var $offerImages = $slotsGameContainer.data('popup-prize-image-paths') || '';
      var $offerImageAlts = $slotsGameContainer.data('popup-prize-image-alts') || '';
      var $shopNowUrls = $slotsGameContainer.data('shop-now-redirect') || '';
      var $offerTitles = $slotsGameContainer.data('popup-offer-titles') || '';
      var $offerDescriptions = $slotsGameContainer.data('popup-offer-descriptions') || '';
      var $winningOfferImage = $('.js-game-win-popup-offer-image', $slotsGameContainer);
      var $winningOfferTitle = $('.js-game-win-popup-offer-title', $slotsGameContainer);
      var $winningOfferDescription = $('.js-game-win-popup-offer-description', $slotsGameContainer);
      var $winGameContentWrapper = $('.js-game-win-popup-wrapper', $slotsGameContainer);
      var $loseGameContentWrapper = $('.js-game-lose-popup-wrapper', $slotsGameContainer);
      var $remainingSpins = $('.js-game-remaining-spins', $slotsGameContainer);
      var $overlayBackground = $('#cboxOverlay');
      var $playAgain = $('.js-game-play-again');
      var isOfferRedeemed = false;
      var gameResetDelay = 1000;
      var isDesktop = window.innerWidth > 1024;
      var slotsOptions = {
        spinTime: 200,
        noOfSpins: 10
      };

      /**
       * Split delimited field from drupal. This assumes that the delimiter
       * is ^===^.
       *
       * @param {string} text - The string to split
       * @returns {Array} the split fields
       */
      function splitField(text) {
        var fields = [];
        var trimmedText;

        if (!text) {
          return [];
        }
        trimmedText = text.trim();
        if (trimmedText.length) {
          fields = trimmedText.split('^===^');
        }

        return fields;
      }

      /**
       * Generates a random number but insure it's not one found within an array
       *
       * @param {number} maxNum - Max number to generate
       * @param {array} excludeNumberArray - Array of Numbers to be ignored
       * from the random number generated.
       *
       * @returns {number} Random number
       */
      function ensureRandomNumber(maxNum, excludeNumberArray) {
        var randomNum = Math.floor(Math.random() * maxNum);

        if (excludeNumberArray.includes(randomNum)) {
          return ensureRandomNumber(maxNum, excludeNumberArray);
        }

        return randomNum;
      }

      /**
       * Generates a random number but ensure
       * it is not already returned more than twice.
       *
       * @param {number} maxLimit - Max number to generate
       * @param {number} excludeNumberArray - Array of Numbers
       * to ignore if occurance is more than
       * 1 from the random number generated
       * We can ignore 5 or 6, etc., from the range of
       * numbers generated or by default 0 can be ignored
       *
       * @returns {number} Random number
       */
      function ensureNumberNotSame(maxLimit, excludeNumberArray) {
        var randomNum = Math.floor(Math.random() * maxLimit);
        var randomNumOccurance = excludeNumberArray.filter(function (value) {
          return value === randomNum;
        }).length;

        if (randomNumOccurance > oneVal) {
          return ensureNumberNotSame(maxLimit, excludeNumberArray);
        }

        return randomNum;
      }

      /**
       * Check if the user has already played
       * the game
       *
       * @returns {boolean} false
       */
      function isAlreadyPlayed() {
        var winningOffer = randomPrize.getWinningOfferCookie();
        var oneDayCookie = randomPrize.get24HourCookie();

        return winningOffer && oneDayCookie;
      }

      /**
       * Calculate the number of spins left.
       *
       * @returns {number} The number of remaining spins.
       */
      function calcSpinsLeft() {
        spinsLeft = totalTries - currentTry;

        if (randomPrize.getCookie('game_offer_applied')) {
          return zeroVal;
        }
        if (spinsLeft < zeroVal) {
          spinsLeft = zeroVal;
        }

        return spinsLeft;
      }

      /**
       * Return the winning offer code.
       *
       * @returns {string} The winning offer code
       */
      function getWinningOfferCode() {
        var offerCode;
        var winningOfferInfo = randomPrize.getWinningOffer();

        if (winningOfferInfo.winning_offer) {
          offerCode = winningOfferInfo.winning_offer.offer_code;
        } else {
          offerCode = randomPrize.offer_array[0];
          randomPrize.winningOfferCode = offerCode;
        }

        return offerCode;
      }

      /**
       * On Redeem/Shop now CTA click
       *
       * @returns {boolean} false
       */
      function shopNowRedirect() {
        var shopNowUrlValues = $shopNowUrls.trim();
        var shopNowUrls;
        var offerCode;
        var redirectUrl;

        if (shopNowUrlValues.length) {
          shopNowUrls = shopNowUrlValues.split('^===^');
          offerCode = randomPrize.getWinningOffer().winning_offer.offer_code;
          redirectUrl = shopNowUrls[randomPrize.offer_array.indexOf(offerCode)];
          location.href = redirectUrl;
        }
      }

      /**
       * Update the page contents for the winning offer.
       *
       * @returns {boolean} false
       */
      function updateWinningOffer() {
        var offerInfo = randomPrize.getWinningOffer();
        var offerDescriptionFromOM = offerInfo.winning_offer?.description;
        var offerImageFromOM = offerInfo.winning_offer?.image;
        var offerTitlesArray = splitField($offerTitles);
        var offerDescriptionsArray = splitField($offerDescriptions);
        var offerImagesArray = splitField($offerImages);
        var offerImageAltsArray = splitField($offerImageAlts);
        var winningOfferCode = getWinningOfferCode();
        var index = randomPrize.offer_array.indexOf(winningOfferCode) || zeroVal;
        var winOfferImage =
          offerImagesArray.length > zeroVal ? offerImagesArray[index] : offerImageFromOM;
        var winOfferImageAlt =
          offerImageAltsArray.length > zeroVal ? offerImageAltsArray[index] : '';

        // Inject winning offer info
        if (offerTitlesArray.length > zeroVal) {
          $winningOfferTitle.html(offerTitlesArray[index]);
        }
        if (offerDescriptionsArray.length > zeroVal) {
          $winningOfferDescription.html(offerDescriptionsArray[index]);
        } else {
          $winningOfferDescription.html(offerDescriptionFromOM);
        }

        if (!offerInfo.winning_offer) {
          offerInfo.winning_offer = {
            winningOfferCode: randomPrize.winningOfferCode,
            description: $offerDescriptions,
            title: $offerTitles,
            image: winOfferImage
          };
        }
        // Inject winning offer image
        $winningOfferImage.attr('src', winOfferImage);
        $winningOfferImage.attr('alt', winOfferImageAlt);
      }

      /**
       * When play again button is clicked, automatically start the spin again
       * @param {object} $spinAgainBtn - The Play again Button element.
       *
       * @returns {boolean} false
       */
      function initPlayAgain($spinAgainBtn) {
        $spinAgainBtn.off('click').on('click', () => {
          // Short delay to allow the animations to reset
          if (isOfferRedeemed || calcSpinsLeft() <= 0) {
            setTimeout(alreadyPlayedPopup, gameResetDelay);
          } else {
            generic.overlay.hide();
            setTimeout(() => $playNowBtn.trigger('click'), gameResetDelay);
          }
        });
      }

      /**
       * Randomise the icons so they are different everytime you load the page
       * @returns {bool} false
       */
      function randomiseIcons() {
        currentlyShowing = [];
        $slotContainer.each(function () {
          // Change the currently shown icon.
          var $slotImages = $(this).find('.js-game-slot-image');
          var randomPoint = ensureRandomNumber($slotImages.length, currentlyShowing);
          var stopPoint = $($slotImages[randomPoint]).position().top;

          currentlyShowing.push(randomPoint);

          $(this).css({ bottom: stopPoint });
        });
      }

      /**
       * Order the icons as per the previous spin.
       * @returns {bool} false
       */
      function orderIconsByPrevSpin() {
        var slotIconsOrder = randomPrize.getCookie('game_slot_icons');

        if (slotIconsOrder) {
          currentlyShowing = slotIconsOrder.split(COOKIE_DELIMITER).map(Number);
        }
        if (currentlyShowing.length <= 0) {
          return false;
        }
        $slotContainer.each(function (index) {
          var $slotImages = $(this).find('.js-game-slot-image');
          var randomPoint = currentlyShowing[index];
          var stopPoint = $($slotImages[randomPoint]).position().top;

          $(this).css({ bottom: stopPoint });
        });
      }

      /**
       * Slot Animation Function
       * @param {object} $thisSlotContainer - The slot container that
       * is going to be animated.
       * @param {number} perSpinHeight - Height to be traversed per spin.
       * @param {number} count - No.of times the slot have to spin.
       * @param {number} endPoint - stop point of the Animation.
       * @param {number} index - index of the slot Container..
       * @param {function} onComplete (optional) - An on Function to be
       * run after the animation is over.
       *
       * @returns {bool} false
       */
      function animateSlots($thisSlotContainer, perSpinHeight, count, endPoint, index, onComplete) {
        $thisSlotContainer.css({ bottom: perSpinHeight }).animate(
          {
            bottom: zeroVal
          },
          slotsOptions.spinTime - index * 50,
          function () {
            var counter = count;

            if (counter > zeroVal) {
              counter = counter - oneVal;
              animateSlots($thisSlotContainer, perSpinHeight, counter, endPoint, index, onComplete);
            } else {
              $thisSlotContainer.animate(
                {
                  bottom: endPoint
                },
                slotsOptions.spinTime - index * 50,
                onComplete()
              );
            }
          }
        );
      }

      /**
       * Shows the win result screen
       *
       * @returns {bool} false
       */
      function showWinBox() {
        var offerInfo = randomPrize.getWinningOffer();
        var confirmMessage = offerInfo.winning_offer?.confirm_message;
        var $overlayPlayAgainBtn;
        var $overlayApplyOfferBtn;
        var $overlay;
        var contentWidth = $slotsGameContainer.data('win-overlay-width') || '80%';
        var contentHeight = $slotsGameContainer.data('win-overlay-height') || '80%';

        if (!offerInfo || !offerInfo.winning_offer) {
          offerInfo = {};
          offerInfo.winning_offer = {
            winningOfferCode: randomPrize.winningOfferCode
          };
        }

        updateWinningOffer();
        // Show win offer popup
        if (generic.overlay) {
          generic.overlay.launch({
            content: $winGameContentWrapper.html(),
            overlayClose: true,
            closeButton: true,
            escKey: false,
            cssClass: 'slot-machine-game__win-overlay js-game-win-popup-overlay js-game-overlay',
            cssStyle: {
              width: contentWidth,
              height: contentHeight
            },
            onComplete: function () {
              $overlayPlayAgainBtn = $('#cboxContent', context).find('.js-game-play-again');
              $overlayApplyOfferBtn = $('#cboxContent', context).find('.js-apply-offer');
              $overlay = $('#colorbox.js-game-win-popup-overlay', context);
              var modalHeight = parseInt(contentHeight, 10) + 150;
              var isOverflowModal = modalHeight > window.innerHeight;

              $overlay.find('.slot-machine-game__win-content').css({
                'min-height': `calc(${contentHeight} - 100px)`,
                'max-width': '100vw'
              });
              $overlay.find('#cboxLoadedContent, #cboxWrapper, #cboxContent').css({
                'min-height': `calc(${contentHeight} + 150px)`,
                height: 'auto',
                width: 'auto',
                'max-width': '100vw'
              });

              if (isDesktop) {
                isOverflowModal = (modalHeight - 100) > window.innerHeight;
                $overlay.find('#cboxLoadedContent, #cboxWrapper, #cboxContent').css({
                  'min-height': `calc(${contentHeight} + 50px)`,
                  width: `calc(${contentWidth} + 100px)`,
                  margin: '0 auto'
                });

                $overlay.css({
                  display: isOverflowModal ? 'block' : 'flex',
                  'align-items': isOverflowModal ? 'flex-start' : 'center',
                  'justify-content': 'center',
                  top: '0',
                  left: '0',
                  'overflow-y': 'auto',
                  'max-width': '100vw',
                  width: '100%',
                  height: '100%'
                });
              } else {
                $overlay.css({
                  height: '100vh !important',
                  width: '100vw'
                });

                setTimeout(function () {
                  $overlay.css({
                    display: isOverflowModal ? 'block' :'flex',
                    'align-items': isOverflowModal ? 'flex-start' : 'center',
                    'overflow-y': 'auto',
                    top: '0'
                  });
                }, 500);
              }

              if ($slotsGameContainer.data('win-overlay-bg-transparency')) {
                $overlayBackground.css(
                  'opacity',
                  $slotsGameContainer.data('win-overlay-bg-transparency')
                );
              }

              if ($overlayPlayAgainBtn.length) {
                initPlayAgain($overlayPlayAgainBtn);
              }

              if ($overlayApplyOfferBtn.length) {
                $overlayApplyOfferBtn.off('click').on('click', function (clickEvent) {
                  clickEvent.preventDefault();
                  $(this).addClass('loader');
                  randomPrize.applyOffer();
                });
              }

              $('body, html').css({
                position: 'fixed',
                width: '100%'
              });
              $('#cboxLoadedContent', context).css('overflow', 'visible');
              $('#cboxWrapper').css('position', 'static');
              $overlay.scrollTo(0, 0);
            },
            onCleanup: function () {
              $('body, html').css('position', 'initial');
            }
          });
        }

        /* If the override flag is set then display the offer confirmation
           message in the success popup */
        if (randomPrize.overrideSuccessContent) {
          randomPrize.nodes.successOverlayCopy.html(confirmMessage);
        }
      }

      /**
       * Delete winning offer cookie
       *
       * @returns {bool} false
       */
      function deleteWinningOfferCookie() {
        var date = new Date();

        date.setTime(date.getTime() - (24 * 60 * 60 + 1) * 1000);
        document.cookie = 'winning_offer=;expires=' + date.toGMTString() + ';';
      }

      /**
       * Shows the lose result screen
       *
       * @returns {bool} false
       */
      function showLoseBox() {
        var $overlayPlayAgainBtn;
        var contentWidth = $slotsGameContainer.data('lose-overlay-width') || '40%';
        var contentHeight = $slotsGameContainer.data('lose-overlay-height') || '40%';
        var isOverflowModal = parseInt(contentHeight, 10) > window.innerHeight;
        var $overlay;

        $('html, body').animate({ scrollTop: zeroVal }, 0);
        deleteWinningOfferCookie();

        if (generic.overlay) {
          generic.overlay.launch({
            content: $loseGameContentWrapper.html(),
            overlayClose: true,
            closeButton: true,
            escKey: false,
            cssClass: 'slot-machine-game__lose-overlay js-game-lose-popup-overlay js-game-overlay',
            cssStyle: {
              width: contentWidth,
              height: contentHeight
            },
            onComplete: function () {
              $overlayPlayAgainBtn = $('#cboxContent').find('.js-game-play-again');

              if ($overlayPlayAgainBtn.length > zeroVal) {
                initPlayAgain($overlayPlayAgainBtn);
              }

              if ($slotsGameContainer.data('lose-overlay-bg-transparency')) {
                $overlayBackground.css(
                  'opacity',
                  $slotsGameContainer.data('lose-overlay-bg-transparency')
                );
              }

              $overlay = $('#colorbox.js-game-lose-popup-overlay', context);
              $overlay.find('#cboxLoadedContent, #cboxWrapper, #cboxContent').css({
                'min-height': `${contentHeight}px)`,
                'min-width': `${contentWidth}px)`,
                height: 'auto',
                width: 'auto'
              });
              $overlay.find('.slot-machine-game__lose-container').css({
                'min-height': `${contentHeight}px)`,
                position: 'relative'
              });
              $overlay.find('#cboxContent').css({
                width: isDesktop ? 'auto' : '100%',
                'min-height': '400px'
              });
              $overlay.find('#cboxWrapper').css({
                position: 'relative',
                width: isDesktop ? 'auto' : '100%',
                height: 'auto'
              });
              $overlay.css({
                display: 'flex',
                'align-items': isOverflowModal ? 'flex-start' : 'center',
                'justify-content': 'center',
                height: '100%',
                width: '100%',
                left: '0',
                top: '0'
              });
            },
            onCleanup: function () {
              $('body, html').css('position', 'initial');
            }
          });
        }
      }

      /**
       * Show active slice in the result screen
       *
       * @param {boolean} $willWin - Win or No win based on chances
       * of win per turn defined in CMS
       * @returns {boolean} false
       */
      function showResult($willWin) {
        var winningOfferCode = getWinningOfferCode();

        isSpinningActive = false;

        // Have they won
        if ($willWin && winningOfferCode) {
          setTimeout(showWinBox, gameTransitionDelay);
        } else {
          setTimeout(showLoseBox, gameTransitionDelay);
        }
        randomPrize.set24HourCookie(oneVal);
      }

      /**
       * If the user has played the game, then show them the result screen
       * If the user has lost the game, then show game lost message
       *
       * @returns {boolean} false
       */
      function alreadyPlayedPopup() {
        var offerCodeCookie = randomPrize.getWinningOfferCookie();
        var displayInactiveOverlay =
          randomPrize.settings.showGameInactiveOverlay.length > zeroVal
            ? parseInt(randomPrize.settings.showGameInactiveOverlay, 10)
            : zeroVal;

        if (
          randomPrize.nodes.inactiveOverlayContainer &&
          displayInactiveOverlay &&
          isOfferRedeemed
        ) {
          randomPrize.gameInactiveOverlay();
          $playAgain.add($remainingSpins).addClass('hidden');
        }
        if (offerCodeCookie !== 'none' && !isOfferRedeemed) {
          $slotsGameContainer.addClass('spin-game--already-played');
          randomPrize.gameInactiveOverlay();
        }

        var $overlay = $('#colorbox.js-game-inactive-overlay-bg');
        var contentWidth = $overlay.find('#cboxContent').width();
        var contentHeight = $overlay.find('#cboxContent').height();
        var modalHeight = $overlay.find('#cboxLoadedContent').height();
        var isOverflowModal = modalHeight > window.innerHeight;
        var topOffset = !isOverflowModal ? (window.innerHeight - modalHeight) / 2 : 0;

        $overlay.find('#cboxWrapper').css({
          width: `${contentWidth + 100}px`,
          overflow: 'visible',
          position: 'relative'
        });

        contentHeight = $slotsGameContainer.data('lose-overlay-height') || 400;
        isOverflowModal = contentHeight > window.innerHeight;
        topOffset = !isOverflowModal ? (window.innerHeight - contentHeight) / 2 : 0;

        $overlay.css({
          display: 'flex',
          'align-items': isOverflowModal ? 'flex-start' : 'center',
          width: isDesktop ? '100%' : 'auto',
          background: 'none',
          overflow: 'visible',
          left: '0',
          top: isOverflowModal || isDesktop ? '0' : `${topOffset}px`,
          height: '100%',
          'justify-content': 'center'
        });

        $overlay.find('#cboxContent').css({
          'position': 'relative',
          height: `${contentHeight + 50}px`,
          width: '100%',
          'min-height': `${contentHeight}px`,
          'min-width': isDesktop ? '500px': '100%'
        });

        $overlay
          .find('#cboxContent .js-random-gift-picker-inactive-overlay-content')
          .height(`${contentHeight}px`);

        $('body, html').css('position', 'initial');

        setTimeout(() => {
          $overlay.find('#cboxLoadedContent, #cboxWrapper').css({
            'min-height': 'unset',
            'min-width': 'unset',
            height: 'auto',
            width: isDesktop ? 'auto' : '100%'
          });
          $overlay.find('#cboxContent').css({
            height: 'auto'
          });
          window.scrollTo(0, 0);
        }, 500);
      }

      /**
       * Show the remaining Spins under the spin button
       *
       * @returns {boolean} false
       */
      function showRemainingSpins() {
        var remainingSpins = totalTries - currentTry;
        var dataAttributeName =
          remainingSpins !== oneVal ? 'spins-remaining-plural' : 'spins-remaining-singular';
        var remainingSpinsMessage = $slotsGameContainer.data(dataAttributeName);

        if (remainingSpinsMessage && remainingSpinsMessage.length) {
          $remainingSpins.html(remainingSpinsMessage.replace('::count::', remainingSpins));
        }
      }

      /**
       * On Click Function for the Play Button
       *
       * @returns {bool} false
       */
      function playGame() {
        var willWin = currentTry + oneVal === totalTries ? oneVal : randomPrize.winOrNoWin();
        var randomWinPoint = randomPrize.getRandomNumber(zeroVal, $slotImageContainer.length / 3);
        var stopPoint;
        var winningOfferCookie;

        currentlyShowing = [];

        if ($(this).hasClass('disabled')) {
          return;
        }
        /* If the user has already played and also if try
           count reached threshold then display message and exit */
        if (isAlreadyPlayed() && currentTry >= totalTries) {
          alreadyPlayedPopup();

          return;
        }
        if (isSpinningActive) {
          return;
        }
        isSpinningActive = true;
        currentTry += oneVal;

        // Show remaining spins count below play again button
        showRemainingSpins();
        randomPrize.setNumberOfTriesCookie(oneVal);

        // Once play game / play again CTA is clicked, calculate new prize
        if (randomPrize.isGameValidforPlay()) {
          winningOfferCookie = randomPrize.winning_offer?.offer_code || randomPrize.offer_array[0];
          randomPrize.setPrize(randomPrize.offer_array, randomPrize.offer_probability);
          randomPrize.getPrize();
          randomPrize.setWinningOfferCookie(winningOfferCookie);
        }

        // Okay now play the game
        $slotContainer.each(function (index) {
          var $slotImages = $(this).find('.js-game-slot-image');
          var perSpinHeight = slotHeight * ($slotImages.length - oneVal);
          var spinsCount = slotsOptions.noOfSpins + index * 2;
          // Spin to random
          var randomPoint = ensureNumberNotSame($slotImages.length, currentlyShowing);

          if (!willWin) {
            currentlyShowing.push(randomPoint);
            stopPoint = $($slotImages[randomPoint]).position().top;
          } else {
            currentlyShowing.push(randomWinPoint);
            stopPoint = $($slotImages[randomWinPoint]).position().top;
          }

          // This will turn into a spinner
          $(this).addClass('slot-machine--spin-started');
          $('html, body').animate({ scrollTop: $playNowBtn.position().top }, scrollTopDuration);

          animateSlots($(this), perSpinHeight, spinsCount, stopPoint, index, function () {
            $(this).removeClass('slot-machine--spin-started');
            if (index >= $slotImages.length - oneVal) {
              setTimeout(function () {
                showResult(willWin);
              }, gameTransitionDelay);
            }
          });
        });
        randomPrize.setCookie(
          'game_slot_icons',
          currentlyShowing.join(COOKIE_DELIMITER),
          randomPrize.overrideGameEnableTime() || 24
        );
      }

      /**
       * Shows the Offer Applied screen
       *
       * @returns {bool} false
       */
      function showSuccessOverlay() {
        var bgImage = $slotsGameContainer.data('lose-overlay-content-bg-img') || '';
        var $successOverlayContent;
        var isOfferRedeemedAlready = 0;
        var { successOverlayWidth, successOverlayHeight } = randomPrize.settings;

        $('html, body').animate({ scrollTop: zeroVal }, 0);
        if (bgImage) {
          randomPrize.nodes.successOverlayContainer
            .children('.js-random-gift-picker-overlay-content-success')
            .css('background-image', 'url(' + bgImage + ')');
        }

        if (generic.overlay) {
          $('body, html').css('position', 'fixed');
          generic.overlay.launch({
            content: randomPrize.nodes.successOverlayContainer.html(),
            overlayClose: true,
            closeButton: true,
            escKey: false,
            cssClass:
              'slot-machine-game__success-overlay js-game-success-popup-overlay js-game-overlay',
            cssStyle: {
              width: successOverlayWidth,
              height: successOverlayHeight
            },
            onComplete: function () {
              var $overlay = $('#colorbox.js-game-success-popup-overlay', context);
              var $overlaySuccessContent = $overlay.find('.js-random-gift-picker-overlay-content-success');

              $overlay.find('#cboxContent').parent().addClass('overlay-game-content');
              if ($slotsGameContainer.data('success-use-lose-popup-bg-settings')) {
                $successOverlayContent = $overlay.find(
                  '.js-random-gift-picker-overlay-content-success'
                );
                if (bgImage) {
                  $successOverlayContent.css('background-image', 'url(' + bgImage + ')');
                }
                if ($slotsGameContainer.data('lose-overlay-content-bg-color')) {
                  $successOverlayContent.css(
                    'background-color',
                    $slotsGameContainer.data('lose-overlay-content-bg-color')
                  );
                }
                if ($slotsGameContainer.data('lose-overlay-bg-transparency')) {
                  $overlayBackground.css(
                    'opacity',
                    $slotsGameContainer.data('lose-overlay-bg-transparency')
                  );
                }
              }
              $document.trigger('game.randomizer.offer.update.status');
              isOfferRedeemedAlready = parseInt(randomPrize.getCookie('game_offer_applied'), 10);
              randomPrize.updateOffer($overlay, isOfferRedeemedAlready);
              $overlay.find('#cboxLoadedContent, #cboxWrapper, #cboxContent').css({
                width: 'auto',
                height: 'auto',
                'min-height': isDesktop ? `${successOverlayHeight}px` : 'auto',
                'min-width': isDesktop ? `${successOverlayWidth}px` : 'auto'
              });

              $overlay.find('#cboxLoadedContent').css({
                overflow: 'visible'
              });

              $overlaySuccessContent.css({
                width: isDesktop ? `${successOverlayWidth}px` : '90vw'
              });

              $overlay.css({
                display: 'flex',
                'align-items': 'center',
                'justify-content': 'center',
                height: '100%',
                width: '100%',
                left: '0',
                top: '0'
              });

              setTimeout(() => {
                $overlay.find('#cboxWrapper').css({
                  'min-height': `${successOverlayHeight}px)`,
                  height: 'unset',
                  width: isDesktop ? 'auto' : '100%'
                });
              }, 100);
            },
            onCleanup: function () {
              $('body, html').css('position', 'initial');
            }
          });
        }
      }

      /**
       * Show success overlay once offer is applied
       *
       * @returns {boolean} false
       */
      function onOfferAppliedResolve() {
        var displaySuccessOverlay =
          randomPrize.settings.showSuccessOverlay.length > zeroVal
            ? parseInt(randomPrize.settings.showSuccessOverlay, 10)
            : zeroVal;

        randomPrize.setCookie(
          'game_offer_applied',
          oneVal,
          randomPrize.overrideGameEnableTime() || 24
        );
        randomPrize.set24HourCookie(oneVal);
        if (displaySuccessOverlay) {
          showSuccessOverlay();
          $playAgain.add($remainingSpins).addClass('hidden');
          if (isOfferRedeemed || calcSpinsLeft() <= zeroVal) {
            $playNowBtn.off('click').on('click', alreadyPlayedPopup);
          }
        } else {
          shopNowRedirect();
        }
      }

      /**
       * Initiate randomizer game when this
       * template loads
       *
       * @returns {boolean} false
       */
      function initRandomPrize() {
        // Setup the stats for the spinner
        slotHeight = $slotImageContainer.first().height();

        if (!randomPrize.getCookie('game_slot_icons')) {
          // Randomise the icons regardless.
          randomiseIcons();
        } else {
          // Order the icons as per the previous spin.
          orderIconsByPrevSpin();
        }

        randomPrize.stopGameFor24HoursOnceWon = 0;
        randomPrize.getPrizeOnPageLoad = false;
        randomPrize.init({ defaultPrize: true });

        totalTries = randomPrize.settings.numberOfTries;
        currentTry = parseInt(randomPrize.getNumberOfTriesCookie(), 10);
        isOfferRedeemed = parseInt(randomPrize.getCookie('game_offer_applied'), 10);
        if (!isOfferRedeemed) {
          $applyOfferBtn.removeClass('hidden');
        }

        $.when(randomPrize.offerApplied).then(function () {
          onOfferAppliedResolve();
        });

        $.when(randomPrize.GameReady).then(function () {
          $('html, body').animate({ scrollTop: zeroVal }, scrollTopDuration);
          showRemainingSpins();
          if (isOfferRedeemed || calcSpinsLeft() <= zeroVal) {
            randomPrize.hideLoading();
            alreadyPlayedPopup();
          }
        });
      }

      /**
       * Callback function that executes once offer has been removed
       * @returns {boolean} false
       */
      function onOfferRemoval() {
        var $container = $('.js-game-inactive-overlay-bg, .js-game-success-popup-overlay', context);
        var $removeOfferButton = $('.js-remove-offer', $container);
        var $addOfferButton = $('.js-add-offer', $container);
        var successUrl = $removeOfferButton.data('successUrl')?.trim();

        randomPrize.deleteCookie('game_offer_applied');
        if (successUrl) {
          window.location.href = successUrl;
        }
        $addOfferButton.removeClass('hidden');
        $removeOfferButton.addClass('hidden');
      }

      /*
        Update remove/add offer cta in the overlay
        based on the APPLIED OFFERS cookie
        @returns {boolean} false
      */
      function updateRemoveOfferCta() {
        var offerAvailability = $.cookie('APPLIED_OFFERS')?.trim().indexOf(getWinningOfferCode());

        if (offerAvailability === -1) {
          onOfferRemoval();
        }
      }

      $(window).on('resize', _.debounce(orderIconsByPrevSpin, 100));
      initRandomPrize();
      $('html, body').animate({ scrollTop: zeroVal }, scrollTopDuration);
      if (isOfferRedeemed || calcSpinsLeft() <= zeroVal) {
        randomPrize.hideLoading();
        $playNowBtn.off('click').on('click', alreadyPlayedPopup);
      } else {
        $playNowBtn.off('click').on('click', playGame);
      }
      $document
        .on('game.randomizer.offer.remove.success', onOfferRemoval)
        .on('game.randomizer.offer.applied.success', onOfferAppliedResolve)
        .on('game.randomizer.offer.update.status', updateRemoveOfferCta);
    }
  };
})(jQuery);
